enum NorwegianCharacters {
    'æ' = 'ae',
    'ø' = 'o',
    'å' = 'a',
}

const toKebabCaseWithoutNorwegianCharacters = (str: string) =>
    str
        .replace(/[æøå]/g, (char) => NorwegianCharacters[char])
        .replace(/[^a-zA-Z0-9\s]/g, '')
        .split(/\W/)
        .join('-');

export default toKebabCaseWithoutNorwegianCharacters;
